// Pillar config drives /articles/pillar/:slug pages, sitemap entries, and
// the visible pillar chips on the Articles index. Aliases match different
// apostrophe encodings in existing post.pillar values.

const normalize = (s) => (s || '').toLowerCase().replace(/[\u2018\u2019']/g, "'").trim();

export const PILLARS = [
  {
    slug: 'aesthetics',
    name: "Aesthetics with a Physician's Perspective",
    headline: "Aesthetics with a Physician's Perspective",
    description:
      'Evidence-based perspectives on injectables, lasers, microneedling, energy devices, and the aesthetics treatment hierarchy — written by our physicians.',
    metaTitle: "Medical Aesthetics Articles",
    metaDescription:
      "Physician-written articles on Botox, Dysport, Xeomin, Letybo, Thulium and CO2 lasers, RF microneedling, and the aesthetics treatment hierarchy.",
    color: 'bg-rose-50 text-rose-700',
    aliases: ["Aesthetics with a Physician's Perspective"],
  },
  {
    slug: 'longevity-biological-age',
    name: 'Longevity & Biological Age',
    headline: 'Longevity & Biological Age',
    description:
      'How to measure biological age, what actually moves the needle, and the science behind healthspan extension.',
    metaTitle: 'Longevity & Biological Age',
    metaDescription:
      'Physician-written articles on biological age testing, biomarkers, and evidence-based longevity strategies from Akira Signature Care.',
    color: 'bg-emerald-50 text-emerald-700',
    aliases: ['Longevity & Biological Age'],
  },
  {
    slug: 'hormones',
    name: 'Hormones Across the Life Course',
    headline: 'Hormones Across the Life Course',
    description:
      'Perimenopause, menopause, bioidenticals and the evidence — a physician framework for hormone optimization at every life stage.',
    metaTitle: 'Hormone & Menopause Articles',
    metaDescription:
      'Physician-written articles on perimenopause, menopause, HRT, bioidentical hormones, and hormone optimization across the life course.',
    color: 'bg-violet-50 text-violet-700',
    aliases: ['Hormones Across the Life Course'],
  },
  {
    slug: 'precision-weight-management',
    name: 'Precision Weight Management & Metabolic Health',
    headline: 'Precision Weight Management & Metabolic Health',
    description:
      'GLP-1 medications, metabolic testing, and physician-supervised weight loss — what the science says and how we apply it.',
    metaTitle: 'GLP-1 & Weight Management',
    metaDescription:
      "Physician-written articles on GLP-1 medications, metabolic testing, and Akira's precision weight management protocol.",
    color: 'bg-amber-50 text-amber-700',
    aliases: ['Precision Weight Management & Metabolic Health'],
  },
  {
    slug: 'microbiome-genetics-multi-omics',
    name: 'Microbiome, Genetics & Multi-Omics',
    headline: 'Microbiome, Genetics & Multi-Omics',
    description:
      'How we turn multi-omics data into personalized care — the microbiome, the genome, and the biomarkers in between.',
    metaTitle: 'Multi-Omics & Genetics',
    metaDescription:
      'Physician-written articles on the microbiome, genetic testing, and multi-omics precision medicine from Akira Signature Care.',
    color: 'bg-sky-50 text-sky-700',
    aliases: ['Microbiome, Genetics & Multi-Omics'],
  },
  {
    slug: 'functional-medicine',
    name: 'Functional & Lifestyle Medicine',
    headline: 'Functional & Lifestyle Medicine',
    description:
      'Root-cause investigation, lifestyle modification, and the gap between "normal labs" and how patients actually feel.',
    metaTitle: 'Functional & Lifestyle Medicine',
    metaDescription:
      'Physician-written articles on functional medicine, root-cause investigation, and lifestyle as medicine.',
    color: 'bg-stone-100 text-stone-700',
    aliases: ['Functional & Lifestyle Medicine'],
  },
  {
    slug: 'founder-story',
    name: 'The Akira Story',
    headline: 'The Akira Story',
    description:
      'Why we built a precision wellness clinic in the San Gabriel Valley — founder perspectives, clinic philosophy, and what makes Akira different.',
    metaTitle: 'The Akira Story — Founder Articles',
    metaDescription:
      'Founder articles on building a physician-led precision wellness clinic in the San Gabriel Valley.',
    color: 'bg-stone-100 text-stone-700',
    aliases: ['Local SEO / Founder Story'],
  },
];

export const getPillarBySlug = (slug) =>
  PILLARS.find((p) => p.slug === slug) || null;

export const getPillarForPost = (pillarValue) => {
  const norm = normalize(pillarValue);
  return PILLARS.find((p) => p.aliases.some((a) => normalize(a) === norm)) || null;
};

export const matchesPillar = (post, pillarConfig) => {
  if (!pillarConfig) return false;
  const norm = normalize(post.pillar);
  return pillarConfig.aliases.some((a) => normalize(a) === norm);
};
